import React from 'react';
import { useAuth } from 'react-oidc-context';
import {
  Box,
  Typography,
  Paper,
  Button,
  Alert,
  CircularProgress,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  margin: theme.spacing(4),
  maxWidth: 800,
  marginLeft: 'auto',
  marginRight: 'auto',
}));

function Auth() {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (auth.error) {
    return (
      <StyledPaper>
        <Alert severity="error" sx={{ mb: 2 }}>
          Authentication Error: {auth.error.message}
        </Alert>
        <Button variant="contained" color="primary" onClick={() => auth.signinRedirect()}>
          Try Again
        </Button>
      </StyledPaper>
    );
  }

  if (!auth.isAuthenticated) {
    return (
      <StyledPaper>
        <Typography variant="h4" gutterBottom>
          Welcome to your profile
        </Typography>
        <Typography variant="body1" paragraph>
          Please sign in to access the full content of your profile.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => auth.signinRedirect()}
          sx={{ mt: 2 }}
        >
          Sign In
        </Button>
      </StyledPaper>
    );
  }

  // If authenticated, redirect to profile page
  window.location.replace('/profile');
  return null;
}

export default Auth; 